import { useEffect, useState } from "react";
import { FeatureType } from "../type";
import getfeatureDetailId from "../function/getfeatureDetailId";
import updateFeature from "../function/updatefeature";

interface EditFeatureModalProps {
    featureId?: number;
    onClose: () => void;
}

const EditFeatureModal = ({ featureId, onClose }: EditFeatureModalProps) => {
    const [feature, setFeature] = useState<FeatureType | null>(null);
    const [featureName, setFeatureName] = useState<string>("");
    const [featureDescription, setFeatureDescription] = useState<string>("");
    const [featureKey, setFeatureKey] = useState<string>("");
    const [featureValue, setFeatureValue] = useState<number | null>(null);

    useEffect(() => {
        if (featureId) {
            getfeatureDetailId(featureId).then((data) => {
                if (data) {
                    setFeature(data);
                    setFeatureName(data.name);
                    setFeatureDescription(data.description);
                    setFeatureKey(data.key || "");
                    setFeatureValue(data.number || null);
                }
            });
        }
    }, [featureId]);

    async function handleSaveChanges() {
        if (typeof featureId === "number") {
            await updateFeature(featureId, {
                name: featureName,
                description: featureDescription,
                key: featureKey || undefined,
                number: featureValue !== null ? featureValue : undefined,
            });
            onClose();
        }
    }
    return (
        <div className=" w-full">
            {feature ? (
                <div className="flex flex-col gap-4">
                    <div className="flex flex-col gap-2">
                        <label className="font-medium">Feature Name</label>
                        <input
                            value={featureName}
                            type="text"
                            className="border bg-white p-2 rounded-lg w-full"
                            placeholder="Enter feature name"
                            onChange={(e) => setFeatureName(e.target.value)}
                        />
                    </div>
                    <div className="flex flex-col gap-2">
                        <label className="font-medium">Feature Description</label>
                        <textarea
                            value={featureDescription}
                            className="min-h-[100px] bg-white border p-2 rounded-lg w-full"
                            placeholder="Enter feature description"
                            onChange={(e) => setFeatureDescription(e.target.value)}
                        ></textarea>
                    </div>
                    {feature.key && (
                        <div className="flex flex-col gap-2">
                            <label className="font-medium">Feature Key</label>
                            <input
                                value={featureKey}
                                type="text"
                                className="border bg-white p-2 rounded-lg w-full"
                                placeholder="Enter feature key"
                                onChange={(e) => setFeatureKey(e.target.value)}
                            />
                        </div>
                    )}
                    {feature.number !== null && (
                        <div className="flex flex-col gap-2">
                            <label className="font-medium">Feature Value</label>
                            <input
                                value={featureValue !== null ? featureValue : ''}
                                type="number"
                                className="border bg-white p-2 rounded-lg w-full"
                                placeholder="Enter feature value"
                                onChange={(e) => setFeatureValue(Number(e.target.value))}
                            />
                        </div>
                    )}
                </div>
            )
                : (
                    <p>Loading feature details...</p>
                )
            }
            <div className="flex justify-end gap-2 p-4">
                <button onClick={onClose} className="px-4 py-2 rounded-lg bg-gray-300 hover:bg-gray-400 transition-colors">
                    Cancel
                </button>
                <button
                    onClick={handleSaveChanges}
                    className="px-4 py-2 rounded-lg bg-blue-600 !text-white hover:bg-blue-700 transition-colors ml-2">
                    Save Changes
                </button>
            </div>
        </div>
    );
}

export default EditFeatureModal;